export default () => {
  const active_grid = document.querySelector('[data-change-grid].active');
  let tiles_per_row = active_grid?.dataset.perRow ? Number(active_grid.dataset.perRow) : 4;
  const adjust_title_height = false;

  // We don't have the layout change on the search results page
  if (typeof tiles_per_row === 'undefined' || isNaN(tiles_per_row)) {
    tiles_per_row = 4;
  }

  if (window.theme.breakpoints.current === 'mobile') {
    tiles_per_row = 2;
  }

  // Remove inline styles from all product tile titles
  if (adjust_title_height) {
    document.querySelectorAll('[data-product-tile-title]').forEach(el => el.removeAttribute('style'));
  }

  let total_per_row = 0; // count the number of tiles on the current row
  let max_title_height = 0;
  let tiles_in_row = [];
  let current_row = 1;

  const firstImgContainer = document.querySelector('.product-tile__image-container');
  const img_container_height = firstImgContainer ? firstImgContainer.offsetHeight : 0;

  document.querySelectorAll('.grid > div').forEach((item, index) => {
    let ignore_item = false;

    // It's possible we get a few other div elements in it, we just ignore them
    const item_type = item.classList.contains('product-tile') ? 'product_tile' : 
                      item.classList.contains('plp-mb') ? 'marketing_block' : 
                      item.classList.contains('product-tile-pagination') ? 'pagination' : '';

    if (item_type === '') {
      ignore_item = true;
    }

    if ((window.theme.breakpoints.current === 'mobile' && item.classList.contains('hidden--mobile')) || 
        (window.theme.breakpoints.current !== 'mobile' && item.classList.contains('hidden--desktop'))) {
      ignore_item = true;
    }

    if (!ignore_item) {
      // We reached the end of the row
      if (total_per_row === tiles_per_row) {
        // Assign the same height to all product tiles in row
        tiles_in_row.forEach(tile => {
          if (adjust_title_height) {
            const title_el = tile.querySelector('[data-product-tile-title]');
            if (title_el) {
              title_el.style.height = `${max_title_height}px`;
            }
          }

          if (tile.classList.contains('product-tile-pagination') && img_container_height > 0) {
            const link_el = tile.querySelector('.product-tile-pagination__link');
            if (link_el) {
              link_el.style.setProperty('height', `${img_container_height}px`, 'important');
            }
          }
        });

        total_per_row = 0;
        max_title_height = 0;
        tiles_in_row = [];
        current_row++;
      }

      if (item_type === 'product_tile') {
        total_per_row++;

        if (adjust_title_height) {
          const title_el = item.querySelector('[data-product-tile-title]');
          const tile_title_height = title_el?.querySelector('a')?.offsetHeight || 0;

          max_title_height = (tile_title_height > max_title_height) ? tile_title_height : max_title_height;
        }

        tiles_in_row.push(item);
      } else if (item_type === 'marketing_block') {
        switch (item.dataset.format) {
          case 'tile':
            total_per_row++;
            break;
          case 'half':
            total_per_row += 2;
            break;
          case 'full':
            total_per_row += tiles_per_row;
            break;
          default:
            break;
        }
      } else if (item_type === 'pagination') {
        total_per_row++;
        tiles_in_row.push(item);
      }
    }
  });

  // Assign the same height to all product tiles in last row
  tiles_in_row.forEach(tile => {
    if (adjust_title_height) {
      const title_el = tile.querySelector('[data-product-tile-title]');
      if (title_el) {
        title_el.style.height = `${max_title_height}px`;
      }
    }

    if (tile.classList.contains('product-tile-pagination') && img_container_height > 0) {
      const link_el = tile.querySelector('.product-tile-pagination__link');
      if (link_el) {
        link_el.style.setProperty('height', `${img_container_height}px`, 'important');
      }
    }
  });

  tiles_in_row = [];
};
